import React, { useState } from 'react';
import { formatPhone } from '../../Utils/Formatters';
import { TbChecklist, TbLock, TbMapPin, TbUserSquareRounded } from 'react-icons/tb';
import { useLocation, useNavigate } from 'react-router-dom';
import Confirm from './Confirm';
import Modal from './Modal';
import { useLoginContext } from '../../Contexts/LoginContext';
import { MdVerified } from 'react-icons/md';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { useCartHook } from '../../Hooks/CartHook';
import { useCartContext } from '../../Contexts/CartContext';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import LinkProfile from './LinkProfile';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useTranslation } from 'react-i18next';

const MenuProfile = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [ showModalConfirmLogout, setShowModalConfirmLogout ] = useState(false);
  const { user } = useLoginContext();
  const { company } = useLayoutContext();
  const { orderType, getOrderTypeIdByName } = useOrderTypeContext();
  const { removeAll, removeLogin } = useCartHook();
  const { currentCart } = useCartContext();
  const navigate = useNavigate();
  const { getLinkToHome } = useStoreHook();

  const handleSSOResetCredentials = () => {
    if (!company) return null;
    const redirectPath = `${process.env.REACT_APP_URL_SSO_RESET_CREDENTIALS!}?company=${company.hash}&redirect=${window.location.pathname}`;
    window.location.href = redirectPath;
  }

  const menu = [
    { path: '/perfil', label: t('profile.menu.profile'), active: location.pathname === '/perfil' || location.pathname === '/perfil/dados-cadastrais', icon: <TbUserSquareRounded size={20} />, disabled: false},
    // { path: '/perfil/dados-cadastrais', label: 'Editar', active: location.pathname === '/perfil/dados-cadastrais', icon: <TbUserEdit size={20} />, disabled: false},
    { path: '/perfil/meus-pedidos', label: t('profile.menu.orders'), active: location.pathname === '/perfil/meus-pedidos', icon: <TbChecklist size={20} />, disabled: false},
    { path: '/perfil/meus-enderecos', label: t('profile.menu.addresses'), active: location.pathname === '/perfil/meus-enderecos', icon: <TbMapPin size={20} />, disabled: false},
    // { path: '/perfil/meus-cartoes', label: 'Cartões', active: location.pathname === '/perfil/meus-cartoes', icon: <TbCards size={20} />, disabled: false},
    { onClick: handleSSOResetCredentials, label: t('profile.menu.reset_credentials'), active: location.pathname === '/perfil/alterar-senha', icon: <TbLock size={20} />, disabled: false},
    // { onClick: () => setShowModalConfirmLogout(true), label: 'Sair', icon: <TbLogout size={20} />}
  ];

  const handleLogout = () => {
    const payload = {
      order_type: Number(getOrderTypeIdByName(orderType))
    }
    removeAll(currentCart.cart_id, payload);
    setShowModalConfirmLogout(false)
    removeLogin(false);
    navigate(getLinkToHome());
  }

  return (
    <>
      <div className="md:p-4 pb-1 text-sm relative ">
          <div className='font-bold text-base'>{ user.name }</div>
          { user.email && <div>{ user.email }</div> }
          <div className='relative max-w-max'>
            { user.mobile_phone && formatPhone(user.mobile_phone) }
            { user.mobile_phone && user.mobile_phone_confirmed && <MdVerified className='text-shopfood-success absolute -top-0.5 -right-4' />}
          </div>
      </div>
      <div className="min-h-20 md:h-auto w-full max-w-dvw md:h-full md:min-w-full">
        <div className='absolute left-0 right-0 py-2 md:p-4 md:static md:h-full'>

          <div className="flex relative justify-between justify-center gap-2 z-10 bg-gray-50 shadow-inner md:shadow-none py-4 md:p-0">
            <div className='flex-1 flex flex-row md:flex-col items-center overflow-x-auto no-scrollbar hide-scrollbar space-x-2 space-l-4 md:space-x-0 md:space-y-2 mx-4 md:m-0'>
                {menu.map((item: any, index: number) => (                  
                  <LinkProfile
                    key={index}
                    disabled={item.disabled}
                    path={item.path}
                    label={item.label}
                    active={item.active}
                    icon={item.icon}
                    onClick={item.onClick}
                  />
                ))}
            </div>
          </div>

        </div>
      </div>

      <Modal open={showModalConfirmLogout} className="max-w-sm m-4" onClose={() => setShowModalConfirmLogout(false)} closeable={true}>
        <Confirm
          title={t('login.confirm_logout_title')}
          message=""
          labelConfirm={t('login.confirm_logout_label_button')}
          onConfirm={handleLogout}
          onCancel={() => setShowModalConfirmLogout(false)}
        />
      </Modal>
    </>
  )
}

export default MenuProfile;